import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
export const Delete: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fillRule="evenodd" clipRule="evenodd" d="M12.1719 2.58605C12.4421 2.58605 12.667 2.81035 12.667 3.09576V3.35965C12.667 3.63812 12.4421 3.86937 12.1719 3.86937H0.662724C0.391895 3.86937 0.166992 3.63812 0.166992 3.35965V3.09576C0.166992 2.81035 0.391895 2.58605 0.662724 2.58605H2.68752C3.09883 2.58605 3.45679 2.29369 3.54931 1.88119L3.65535 1.40758C3.82014 0.762452 4.36247 0.333984 4.98315 0.333984H7.85083C8.46476 0.333984 9.01317 0.762452 9.17188 1.37356L9.28535 1.8805C9.3772 2.29369 9.73515 2.58605 10.1471 2.58605H12.1719ZM11.1433 12.2326C11.3547 10.2625 11.7248 5.58198 11.7248 5.53476C11.7383 5.3917 11.6917 5.25629 11.5992 5.14726C11.4999 5.04518 11.3743 4.98476 11.2358 4.98476H1.60352C1.46439 4.98476 1.33202 5.04518 1.24016 5.14726C1.14696 5.25629 1.10103 5.3917 1.10779 5.53476C1.10903 5.54343 1.12231 5.7083 1.14451 5.98394C1.24315 7.20842 1.51786 10.6188 1.69537 12.2326C1.82099 13.4215 2.60106 14.1687 3.73098 14.1958C4.6029 14.2159 5.50116 14.2229 6.41968 14.2229C7.28485 14.2229 8.16352 14.2159 9.06246 14.1958C10.2315 14.1756 11.0109 13.4416 11.1433 12.2326Z" fill="currentColor" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg {...props} stroke="none" width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};